'use client'

import React from 'react'

import { SpaceProps } from '../../themes'
import { FieldContent } from './FieldContent'
import { FieldLabel } from './FieldLabel'
import { FieldMessages } from './FieldMessages'
import { Container } from './styles'

export interface FieldProps extends SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Field children
   */
  children: React.ReactNode
}

type FieldComponent = ((props: FieldProps) => React.ReactNode) & {
  Label: typeof FieldLabel
  Content: typeof FieldContent
  Messages: typeof FieldMessages
}

export const Field: FieldComponent = ({
  className,
  children,
  ...spaceProps
}: FieldProps) => {
  return (
    <Container className={className} {...spaceProps}>
      {children}
    </Container>
  )
}

Field.Label = FieldLabel
Field.Content = FieldContent
Field.Messages = FieldMessages
